import {useMutation, useQueryClient} from '@tanstack/react-query';

import {deleteVideoEventSchedule} from '../api';
import {QUERY__VIDEO_SCHEDULES} from '../queryKeys';

export const useDeleteVideoEventSchedule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (scheduleId: string) => deleteVideoEventSchedule(scheduleId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__VIDEO_SCHEDULES],
      });
    },
  });
};
